import { getLanguageKeyForFilePath } from '../language-registry.js';
import { resolveCDefinitions } from './c.js';
import { resolveCppDefinitions } from './cpp.js';
import { resolveGoDefinitions } from './go.js';
import { resolveJavaDefinitions } from './java.js';
import { resolveJavascriptDefinitions } from './javascript.js';
import { resolvePythonDefinitions } from './python.js';
import { resolveRubyDefinitions } from './ruby.js';
import { resolveRustDefinitions } from './rust.js';
import { resolveTsxDefinitions } from './tsx.js';
import { resolveTypescriptDefinitions } from './typescript.js';
import type { LanguageDefinitionResolver } from './types.js';

export const RESOLVERS_BY_LANGUAGE_KEY: Readonly<Record<string, LanguageDefinitionResolver>> = {
  javascript: resolveJavascriptDefinitions,
  typescript: resolveTypescriptDefinitions,
  tsx: resolveTsxDefinitions,
  python: resolvePythonDefinitions,
  go: resolveGoDefinitions,
  rust: resolveRustDefinitions,
  ruby: resolveRubyDefinitions,
  java: resolveJavaDefinitions,
  c: resolveCDefinitions,
  cpp: resolveCppDefinitions,
};

export const SUPPORTED_RESOLUTION_LANGUAGE_KEYS = Object.freeze(
  Object.keys(RESOLVERS_BY_LANGUAGE_KEY).sort(),
);

export function resolverForLanguageKey(languageKey: string | null): LanguageDefinitionResolver | null {
  if (!languageKey) return null;
  return RESOLVERS_BY_LANGUAGE_KEY[languageKey] ?? null;
}

export function resolverForFilePath(filePath: string): LanguageDefinitionResolver | null {
  return resolverForLanguageKey(getLanguageKeyForFilePath(filePath));
}
